const stepCompletedType = {
  property: 'propertyCompleted',
  pond: 'pondCompleted',
  cycle: 'cycleCompleted',
};

const initialValue = {
  property: false,
  pond: false,
  cycle: false,
};

const userSteps = (state = initialValue, action) => {
  switch (action.type) {
    case stepCompletedType.property:
      return {
        ...state,
        property: action.payload,
      };
    case stepCompletedType.pond:
      return {
        ...state,
        pond: action.payload,
      };
    case stepCompletedType.cycle:
      return {
        ...state,
        cycle: action.payload,
      };
    default:
      return state;
  }
};

export const setPropertyCompleted = (payload) => ({
  type: stepCompletedType.property,
  payload,
});

export const setPondCompleted = (payload) => ({
  type: stepCompletedType.pond,
  payload,
});

export const setCycleCompleted = (payload) => ({
  type: stepCompletedType.cycle,
  payload,
});

export default userSteps;
